import React from "react";
import "./financialOverview.css";

import SideNav from "../Components/sideNav";
import Navbar from "../Components/navbar";
import StatCards from "../Components/statCards";
import BigBar from "../Components/bigBar";
import Sources from "./sources";
import SmallBar from "../Components/smallBar";
import UnderChart from "../Components/underChart";
import ButtonTable from "./buttonTable";

const FinancialOverview = () => {
  const statCardData = [
    {
      body: "$12,750",
      head: "Total Revenue Generated",
      icon: "./images/PvxDashboard/StatCard/Dollar.svg",
    },
    {
      body: "$12,750",
      head: "Total Expenses",
      icon: "./images/PvxDashboard/StatCard/Wallet.svg",
    },
    {
      body: "3000",
      head: "Discount Given",
      icon: "./images/PvxDashboard/StatCard/Discount.svg",
    },
    {
      body: "3000",
      head: "Kpis (Conversion rate)",
      icon: "./images/PvxDashboard/StatCard/Kpis.svg",
    },
    {
      body: "4000",
      head: "Total Subscriptions",
      icon: "./images/PvxDashboard/StatCard/Subs.svg",
    },
    {
      body: "4000",
      head: "Customer Churn rate",
      icon: "./images/PvxDashboard/StatCard/Churn.svg",
    },
    {
      body: "70000",
      head: "Calls to Companies",
      icon: "./images/PvxDashboard/StatCard/Calls.svg",
    },
    {
      body: "4000",
      head: "Renewal Revenue",
      icon: "./images/PvxDashboard/StatCard/Revenue.svg",
    },
  ];

  return (
    <div className="pvxFinancialOveviewColor">
      <Navbar />
      <SideNav active="Financial" />
      <div className="pvxFinancialOveview">
        <StatCards statCardData={statCardData} />
        <div className="b2">
          <Sources />
          <BigBar dropdown={false} title="Revenue Growth Rate" />
        </div>
        <div className="b2">
          <UnderChart title="Subscriptions VS Unsubscriptions" dropdown={true} />
          <SmallBar color="#75C361" title="New Customer Revenue" dropdown={true} />
        </div>
        <div className="b2">
          <ButtonTable title="Subscribers" />
        </div>
      </div>
    </div>
  );
};

export default FinancialOverview;
